import { default as Bluebird } from 'bluebird';
import { BaseDescriptor } from './breakingChangeDescriptors/baseDescriptor';

declare let Ext: any & { define: (className, data, createdFn) => any};
declare let require: any & { context: (directory, useSubdirectories, regExp) => any};
declare let SyncManager: any;

let BreakingChangeManager;
export default Ext.define('FieldServices.singletons.BreakingChangeManager', {
    extend: 'Ext.Base',
    alternateClassName: ['BreakingChangeManager'],
    singleton: true,

    changeDescriptors: {} as Record<string, BaseDescriptor[]>,
    alertQueue: [],
    isShowingAlert: false,

    constructor() {
        this.loadAllDescriptors();
    },

    async loadAllDescriptors() {
        const context = require.context('./breakingChangeDescriptors/', false, /\.\/.*\.ts$/);
        await Bluebird.each(context.keys(), (key: string) => {
            if (key !== './baseDescriptor.ts') {
                const descriptor = new (context(key).default)();
                const { affectedStore } = descriptor;
                descriptor.on('showNotification', this.processAlert.bind(this, descriptor.showAlertNotification.bind(descriptor)));
                descriptor.on('notificationClosed', this.showNextAlert.bind(this));
                if (this.changeDescriptors[affectedStore]) {
                    this.changeDescriptors[affectedStore].push(descriptor);
                } else {
                    this.changeDescriptors[affectedStore] = [descriptor];
                }
            }
        });
    },

    initialize() {
        if (SyncManager.getOnlineSyncEnabled()) {
            SyncManager.on(SyncManager.syncEvents.COMPLETED, this.runChecks, this, { single: true });
            SyncManager.trySync();
        } else {
            SyncManager.on(SyncManager.syncEvents.ONLINESYNC_ENABLED, this.initialize, this, { single: true });
        }
    },

    async runChecks() {
        await Bluebird.each(Object.keys(this.changeDescriptors), async storeName => {
            const affectedStore = Ext.getStore(storeName);
            if (!affectedStore.isLoaded()) {
                await affectedStore.waitToLoad();
            }
            await this.runChecksForStore(storeName);
        });
    },

    async runChecksForStore(storeName: string) {
        const store = Ext.getStore('BreakingChange');
        await Bluebird.each(this.changeDescriptors[storeName], async (descriptor: BaseDescriptor) => {
            await descriptor.runCheck();
        });
        store.sync();
    },

    async processAlert(showAlertFn) {
        if (!this.isShowingAlert) {
            this.isShowingAlert = true;
            await showAlertFn();
        } else {
            this.alertQueue.push(showAlertFn);
        }
    },

    async showNextAlert() {
        this.isShowingAlert = false;
        const nextAlert = this.alertQueue.shift();
        if (nextAlert) {
            await this.processAlert(nextAlert);
        }
    },

}, instance => {
    BreakingChangeManager = instance;
});

export { BreakingChangeManager };
